export default "__VITE_ASSET__CZbTbIA8__"